module.exports = __webpack_public_path__ + "img/09.269d577e.jpg";